import React from "react";
import FLOW1 from "../../../assets/images/flow1.png";
import FLOW2 from "../../../assets/images/flow2.png";

// /document-api?i=user-flow
export default function UserFlow() {
  return (
    <>
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <img
                  alt="FLOW"
                  src={FLOW1}
                  className="w-100 my-3"
                  style={{ maxWidth: 700 }}
                />
              </div>
              <h4 className="fw-bold">Customer Deposit Workflow</h4>
              <h5 className="fw-bold">
                1. Customer Registration and Account Opening
              </h5>
              <p>
                The customer registers and opens a trading/investment account
                with the Broker.
              </p>
              <h5 className="fw-bold">2. Deposit</h5>
              <p>
                The customer wants to deposit funds into their trading account.
                The Broker acts as an intermediary to process the deposit via
                the central system (SwiftGoldPay).
              </p>
              <h5 className="fw-bold">
                3. Request to Generate QR Code for Payment
              </h5>
              <p>
                The Broker calls the SwiftGoldPay API to generate a QR Code,
                which the customer will scan to make the deposit.
              </p>
              <p>The request must include:</p>
              <ul>
                <li>
                  <b>customer_id:</b> Customer ID registered with SwiftGoldPay
                </li>
                <li>
                  <b>amount:</b> Deposit amount
                </li>
                <li>
                  <b>ref_no:</b> Transaction reference number
                </li>
              </ul>
              <h5 className="fw-bold">
                4. Request QR Code from Payment Gateway
              </h5>
              <p>
                SwiftGoldPay sends a request to the Payment Gateway to generate
                the actual QR Code from the bank/payment service provider.
              </p>
              <h5 className="fw-bold">
                5. Receive QR Code from Payment Gateway
              </h5>
              <p>
                The Payment Gateway sends the generated QR Code back to
                SwiftGoldPay.
              </p>
              <h5 className="fw-bold">6. Send QR Code Back to Broker</h5>
              <p>
                SwiftGoldPay returns the QR Code to the Broker via the API
                response.
              </p>
              <h5 className="fw-bold">
                7. Customer Scans QR Code to Make Payment
              </h5>
              <p>
                The Broker displays the QR Code so the customer can scan and
                make the payment using Mobile Banking or a payment application.
              </p>
              <p>
                The money is transferred to the account linked with the Payment
                Gateway.
              </p>
              <h5 className="fw-bold">8. Payment Status Callback</h5>
              <p>
                The Payment Gateway sends a callback (HTTP POST) to SwiftGoldPay
                to notify the payment status.
              </p>
              <h5 className="fw-bold">9. Update Broker’s Account Balance</h5>
              <p>
                SwiftGoldPay records the deposit and updates the Broker’s system
                with the new balance.
              </p>
              <p>
                The Broker can then update their dashboard or customer account
                system accordingly.
              </p>
              <h5 className="fw-bold">
                10. SwiftGoldPay Sends Payment Status Callback to Broker
              </h5>
              <p>
                SwiftGoldPay sends a callback (HTTP POST) back to the Broker to
                notify the payment status.
              </p>

              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <img
                  alt="FLOW"
                  src={FLOW2}
                  className="w-100 my-3"
                  style={{ maxWidth: 700 }}
                />
              </div>
              <h4 className="fw-bold">Customer Withdraw Workflow</h4>
              <h5 className="fw-bold">
                1. Customer Initiates Withdrawal Request
              </h5>
              <p>
                The customer submits a withdrawal request through the Broker
                system.
              </p>
              <div className="fw-bold mb-2">📝 Notes:</div>
              <p>
                Withdrawals can only be made to local bank accounts that the
                customer has pre-linked.
              </p>
              <p>
                The system operates automatically (Withdraw Auto API) and is
                available 24/7.
              </p>
              <h5 className="fw-bold">
                2. Send Withdrawal Request to SwiftGoldPay
              </h5>
              <p>
                The Broker sends a request to SwiftGoldPay via API, including:
              </p>
              <ul>
                <li>
                  <b>customer_id:</b> Customer ID registered with SwiftGoldPay
                </li>
                <li>
                  <b>amount:</b> Withdrawal amount
                </li>
                <li>
                  <b>ref_no:</b> Transaction reference number
                </li>
              </ul>
              <h5 className="fw-bold">
                3. Send Payment Instruction to Payment Gateway
              </h5>
              <p>
                SwiftGoldPay performs initial checks (e.g., account balance,
                fees, liquidity in the central account).
              </p>
              <p>
                Then, it sends a payment instruction to the Payment Gateway to
                transfer the funds.
              </p>
              <ul>
                <li>
                  <b>Transfer Funds to Broker/Customer Account</b> The Payment
                  Gateway transfers the actual money to the specified account.
                </li>
                <li>
                  <b>Send Transaction Result Back to SwiftGoldPay</b> The
                  Payment Gateway sends a response (callback) back to
                  SwiftGoldPay.
                </li>
              </ul>
              <h5 className="fw-bold">4. Update Withdrawal Status</h5>
              <p>
                Upon receiving the response from the Payment Gateway,
                SwiftGoldPay:
              </p>
              <ul>
                <li>
                  Confirms the withdrawal (the amount including fees was already
                  deducted from the Broker's wallet when the request was
                  accepted; if the transfer fails or is cancelled, it is
                  returned to the wallet)
                </li>
                <li>
                  Records the withdrawal status (e.g., "success" or "cancel")
                </li>
                <li>Sends the updated information back to the Broker</li>
              </ul>
              <div className="fw-bold mb-2">📝 Important Notes:</div>
              <ul>
                <li>
                  The system must have a <b>central account</b> with sufficient
                  funds to cover withdrawals and fees.
                </li>
                <li>
                  Only transfers to <b>local banks</b> are supported.
                </li>
                <li>
                  Operators and the API system operate automatically 24/7.
                </li>
              </ul>
    </>
  );
}
